// Small helper: "2 min ago" / "3 h ago" / date fallback
export function relTime(iso) {
  if (!iso) return "";
  try {
    const then = new Date(iso).getTime();
    const now = Date.now();
    const secs = Math.max(0, Math.round((now - then) / 1000));
    if (secs < 60) return `${secs}s ago`;
    const mins = Math.round(secs / 60);
    if (mins < 60) return `${mins} min ago`;
    const hrs = Math.round(mins / 60);
    if (hrs < 24) return `${hrs} h ago`;
    const days = Math.round(hrs / 24);
    if (days < 7) return `${days} d ago`;
    return new Date(iso).toLocaleDateString();
  } catch {
    return "";
  }
}
